/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useCallback, useContext, useState } from 'react'
import { Button, DatePicker, Input, InputNumber, Modal, Spin } from 'antd'

import moment from 'moment'
import { title, updateDataMain } from './Utils'

import { saveMisoVerificationTestata } from 'api/pgads'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { UtilityUnitSelection, dataSavedMessage } from 'core'
import { SpinContext } from 'context'
const CenterLabel = ({ children }) => (
  <div style={{ display: 'grid', justifyContent: 'center' }}>
    <b>{children}</b>
  </div>
)

const RightLabel = ({ children }) => (
  <div
    style={{
      display: 'grid',
      justifyContent: 'right',
      alignContent: 'center',
      height: '100%',
    }}
  >
    {children} :
  </div>
)
const LeftLabel = ({ children, style }) => (
  <div
    style={{
      ...style,
      display: 'grid',
      justifyContent: 'left',
      alignContent: 'center',
    }}
  >
    {children}
  </div>
)

const EmptyRow = _ => <div style={{ gridColumnEnd: 'span 6', height: 10 }} />

const MisoVerificationDialog = ({
  insertdata,
  netCapacityVerificationWrite = false,
  mode = 'U',
  units = [],
  apiTargetInfo,
  ...props
}) => {
  const [data, setData] = useState(insertdata)
  const { setSpinning, spinning } = useContext(SpinContext)
  const onSave = _ => {
    setSpinning(true)
    saveMisoVerificationTestata(apiTargetInfo)(data).fork(
      props.setError,
      error => {
        setSpinning(false)
        props.setTmpError(error)
        if (!isErrorContains(error)) {
          props.setVisible(false)
          dataSavedMessage()
          props.onRetrieve()
        }
      }
    )
  }

  const updateData = useCallback(
    (key, value) => updateDataMain({ key, value, data, setData }),
    [data]
  )
  const updateMultipleData = dataMap => setData({ ...data, ...dataMap })

  const TextXefordComp = useCallback(
    ({ dataKey }) => (
      <Input
        key={dataKey}
        value={data.extendedData && data.extendedData[dataKey]}
        // onChange={(e) => updateData(dataKey, e.target.value)}
        keyName={dataKey}
        size="small"
        disabled
      />
    ),
    [data.extendedData]
  )

  const TextComp = useCallback(
    ({
      dataKey,
      disabled = false,
      data = {},
      updateData,
      max,
      netCapacityVerificationWrite = false,
    }) => (
      <InputNumber
        style={{ width: '100%' }}
        key={dataKey}
        value={data[dataKey]}
        // onChange={(e) => updateData(dataKey, e.target.value)}
        onChange={value => updateData(dataKey, value)}
        keyName={dataKey}
        disabled={!netCapacityVerificationWrite || disabled}
        size="small"
        max={max}
      />
    ),
    []
  )
  const max4 = 9999.9
  const max3 = 999.9
  const max2 = 99.9

  return (
    <Modal
      maskClosable={false}
      title={title}
      visible={props.visible}
      onOk={() => props.setVisible(false)}
      onCancel={() => props.setVisible(false)}
      okButtonProps={{ loading: spinning }}
      cancelButtonProps={{ loading: spinning }}
      destroyOnClose
      closable
      footer={
        <div>
          {netCapacityVerificationWrite && (
            <Button type="primary" onClick={onSave} loading={spinning}>
              Save
            </Button>
          )}
          <Button
            type="primary"
            onClick={() => props.setVisible(false)}
            loading={spinning}
          >
            Cancel
          </Button>
        </div>
      }
      loading={spinning}
      style={{ top: 5, left: 5, width: '90vh' }}
      width="1100px"
      height="90%"
      bodyStyle={{ padding: 5, margin: 5, top: 5 }}
      zIndex={1000}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 120px 200px 100px 100px 50px',
            border: '1px solid black',
            gap: '5px',
            overflow: 'auto',
            height: '80vh',
            padding: 5,
          }}
        >
          <h4>
            <RightLabel css={{ height: '100%' }}>Select Unit</RightLabel>
          </h4>
          <div style={{ gridColumnEnd: 'span 5' }}>
            <UtilityUnitSelection
              utility={data.utility}
              unit={data.unitId}
              onUnitChange={value => {
                const fu = units.find(f => f.unitId === value[1]) || {}
                updateMultipleData({
                  utility: value[0],
                  unit: value[1].substr(3),
                  unitId: value[1],
                  unitType: fu.id1,
                })
              }}
              disabled={mode !== 'I'}
              casStyle={{ width: '100%' }}
            />
          </div>
          <h4>
            <RightLabel css={{ height: '100%' }}>Year </RightLabel>
          </h4>
          <div
            style={{
              gridColumnEnd: 'span 1',
              display: 'flex',
              flexWrap: 'nowrap',
              gap: '5px',
            }}
          >
            {/* {mode === 'I' && (
              <Select
                value={data.year}
                onChange={year => {
                  updateData('year', year)
                }}
              >
                {yearSelect.map(y => (
                  <Select.Option key={y} value={y}>
                    {y}
                  </Select.Option>
                ))}
              </Select>
            )} */}
            {(mode === 'I' || mode === 'E' || mode === 'D' || mode === 'U') && (
              <h4>
                <LeftLabel>{data.year}</LeftLabel>
              </h4>
            )}
          </div>

          <div style={{ gridColumnEnd: 'span 1' }}>
            <h4>Test Index : {data.testIdx === -99 ? '' : data.testIdx}</h4>
          </div>
          <div style={{ gridColumnEnd: 'span 2' }}>
            <h4>Unit Standard : MISO</h4>
          </div>
          <div style={{ gridColumnEnd: 'span 1' }} />
          <EmptyRow />
          <div />
          <CenterLabel>Summer</CenterLabel>
          <CenterLabel>Fall</CenterLabel>
          <CenterLabel>Winter</CenterLabel>
          <CenterLabel>Spring</CenterLabel>
          <div style={{ gridTemplateColumns: 'span 1' }} />

          <RightLabel>Corrected Net Test Capacity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="correctedNetSummer"
            disabled
          />
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="correctedNetFall"
            disabled
          />
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="correctedNetWinter"
            disabled
          />
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="correctedNetSpring"
            disabled
          />
          <LeftLabel>(MW)</LeftLabel>
          <RightLabel>Seasonal XEFORd</RightLabel>
          <TextXefordComp dataKey="xefordSummer" disabled />
          <TextXefordComp dataKey="xefordFall" disabled />
          <TextXefordComp dataKey="xefordWinter" disabled />
          <TextXefordComp dataKey="xefordSpring" disabled />
          <LeftLabel>(%)</LeftLabel>

          <EmptyRow />

          <RightLabel>Gross (MW)</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="grossMW"
            max={max4}
          />
          <div
            style={{
              gridColumnEnd: 'span 4',
              gridRowEnd: 'span 4',
              border: '1px solid gray',
              display: 'grid',
              gridTemplateColumns: '150px auto',
            }}
          >
            <RightLabel>Test Start Date-Time :</RightLabel>
            <DatePicker
              style={{
                alignSelf: 'center',
                justifySelf: 'center',
              }}
              showTime
              format="MM/DD/YYYY HH:mm"
              value={
                data.teststartdate2 ||
                (data.testStartDate &&
                  moment(data.testStartDate, 'YYYY-MM-DDTHH:mm:ss'))
              }
              onChange={date =>
                setData({
                  ...data,
                  testStartDate2: date,
                  testStartDate: date.format('YYYY-MM-DDTHH:mm:ss'),
                })
              }
              disabled={!netCapacityVerificationWrite}
              allowClear={false}
            />
            <RightLabel>Test End Date-Time :</RightLabel>

            <DatePicker
              style={{
                alignSelf: 'center',
                justifySelf: 'center',
              }}
              showTime
              format="MM/DD/YYYY HH:mm"
              value={
                data.testEndDate2 ||
                (data.testEndDate &&
                  moment(data.testEndDate, 'YYYY-MM-DDTHH:mm:ss'))
              }
              onChange={date =>
                setData({
                  ...data,
                  testEndDate2: date,
                  testEndDate: date.format('YYYY-MM-DDTHH:mm:ss'),
                })
              }
              disabled={!netCapacityVerificationWrite}
              allowClear={false}
            />
          </div>
          <RightLabel>Station Service (MW)</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="stationService"
            max={max4}
          />
          <RightLabel>Process Load (MW)</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="processLoadServed"
            max={max4}
          />
          <RightLabel>Net Test Capacity (MW)</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="netTestCapability"
            disabled
          />

          <div style={{ gridColumnEnd: 'span 3' }} />
          <div style={{ gridColumnEnd: 'span 3', textAlign: 'left' }}>
            Observed
          </div>

          <RightLabel>Reactive Gen MVAR (+ or -)</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="reactiveGenMvar"
            max={max4}
          />
          <RightLabel>Dry Bulb Air Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="dryairTempObserved"
            max={max3}
          />
          <LeftLabel style={{ gridColumnEnd: 'span 2' }}>(F)</LeftLabel>
          <RightLabel>Total Power MVA</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="totalPowerMva"
            disabled
          />
          <RightLabel>Relative Humidity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityObserved"
            max={max2}
          />
          <LeftLabel style={{ gridColumnEnd: 'span 2' }}>(%)</LeftLabel>
          <RightLabel>Power Factor</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="powerFactor"
            disabled
          />
          <RightLabel>Cooling Water Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempObserved"
            max={max3}
          />
          <LeftLabel style={{ gridColumnEnd: 'span 2' }}>(F)</LeftLabel>
          <EmptyRow />
          <CenterLabel>Summer</CenterLabel>
          <LeftLabel>Rated</LeftLabel>
          <div />
          <LeftLabel>Correction</LeftLabel>
          <LeftLabel>(+ or -)</LeftLabel>
          <div />

          <RightLabel>Dry Bulb Air Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="dryairTempRatedSummer"
            max={max3}
          />
          <LeftLabel>(F)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="airTempMwCorrSummer"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Relative Humidity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityRatedSummer"
            max={max2}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityMwCorrSummer"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Cooling Water Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempRatedSummer"
            max={max3}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempMwCorrSummer"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />

          <EmptyRow />
          <CenterLabel>Fall</CenterLabel>
          <LeftLabel>Rated</LeftLabel>
          <div />
          <LeftLabel>Correction</LeftLabel>
          <LeftLabel>(+ or -)</LeftLabel>
          <div />
          <RightLabel>Dry Bulb Air Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="dryairTempRatedFall"
            max={max3}
          />
          <LeftLabel>(F)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="airTempMwCorrFall"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Relative Humidity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityRatedFall"
            max={max2}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityMwCorrFall"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Cooling Water Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempRatedFall"
            max={max3}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempMwCorrFall"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />

          <EmptyRow />
          <CenterLabel>Winter</CenterLabel>
          <LeftLabel>Rated</LeftLabel>
          <div />
          <LeftLabel>Correction</LeftLabel>
          <LeftLabel>(+ or -)</LeftLabel>
          <div />
          <RightLabel>Dry Bulb Air Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="dryairTempRatedWinter"
            max={max3}
          />
          <LeftLabel>(F)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="airTempMwCorrWinter"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Relative Humidity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityRatedWinter"
            max={max2}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityMwCorrWinter"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Cooling Water Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempRatedWinter"
            max={max3}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempMwCorrWinter"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />

          <EmptyRow />
          <CenterLabel>Spring</CenterLabel>
          <LeftLabel>Rated</LeftLabel>
          <div />
          <LeftLabel>Correction</LeftLabel>
          <LeftLabel>(+ or -)</LeftLabel>
          <div />
          <RightLabel>Dry Bulb Air Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="dryairTempRatedSpring"
            max={max3}
          />
          <LeftLabel>(F)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="airTempMwCorrSpring"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Relative Humidity</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityRatedSpring"
            max={max2}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="relHumidityMwCorrSpring"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />
          <RightLabel>Cooling Water Temperature</RightLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempRatedSpring"
            max={max3}
          />
          <LeftLabel>(%)</LeftLabel>
          <TextComp
            netCapacityVerificationWrite={netCapacityVerificationWrite}
            updateData={updateData}
            data={data}
            dataKey="cwaterTempMwCorrSpring"
            max={max2}
          />
          <LeftLabel>(MW)</LeftLabel>
          <div />

          <EmptyRow />
          <LeftLabel style={{ gridColumnEnd: 'span 6' }}>Note </LeftLabel>
          <Input.TextArea
            value={data.note}
            onChange={e => setData({ ...data, note: e.target.value })}
            style={{
              gridColumnEnd: 'span 6',
              minHeight: '100px',
              marginBottom: '10px',
              padding: 10,
            }}
            rows={4}
            disabled={!netCapacityVerificationWrite}
            maxLength={3999}
          />
        </div>
      </Spin>
    </Modal>
  )
}

export default MisoVerificationDialog
